import React, { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import { currencyCode } from 'Helpers/Geo/data';
import { fetchLatestOrder } from 'Redux/ducks/orders';
import ProductCover from 'Components/Utility/ProductCover';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';

import 'Components/Account/AccountOverview/SingleOrder.scss';

export default function SingleOrder() {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    fetchLatestOrder().then(setOrder).catch(() => {});
  }, []);

  if (!order || !order.items) return false;

  let orderItem = {};
  let orderItemsNumber = 0;
  let orderTotal = 0;
  if (!isEmpty(order.items)) {
    orderItem = order.items[0];
    orderItemsNumber = order.items.length;
    orderTotal = order.payment.total / 100;
  }

  return (
    <article className="account-table">
      <h2 className="account-table-heading">
        <FormattedMessage id="account-single-order.table.title" defaultMessage="Your Latest Order" />
      </h2>
      <div className="account-table-row account-single-order-container">
        <Link to={`/orders/${order._id}`}>
          <div key={orderItem._id} className="account-single-order">
            <ProductCover
              cover={orderItem.cover}
              alt={`Product cover for ${name}`}
              displayType={orderItem.display_type}
            />
            <div className="single-order-card">
              <div className="single-order-details">
                <div className="item-name-container">
                  {orderItem.name}
                  {(orderItemsNumber - 1) >= 1 &&
                    <span>
                      &nbsp;
                      <FormattedMessage
                        id="account-single-order.item.name.more"
                        defaultMessage="and {orderItemsNumber} more"
                        values={{
                          orderItemsNumber,
                        }}
                      />
                    </span>
                  }
                </div>
                <div className="order-detail-container">
                  <span>
                    <FormattedMessage id="account-single-order.item.order-number" defaultMessage="Order number:" />
                    &nbsp;
                  </span>
                  {order._id}
                </div>
                <div className="order-detail-container">
                  <span>
                    <FormattedMessage id="account-single-order.item.order-date" defaultMessage="Date:" />
                    &nbsp;
                  </span>
                  <FormattedDate value={order.date} year="numeric" month="short" day="2-digit" />
                </div>
                <div className="order-detail-container">
                  <span>
                    <FormattedMessage id="account-single-order.item.order-total" defaultMessage="Total:" />
                    &nbsp;
                  </span>
                  <SpecialFormattedNumber
                    dontConvert
                    value={orderTotal}
                    style="currency"
                    currency={order.loc.currency_alphabetic_code || currencyCode}
                  />
                </div>
              </div>

              <div className="single-order-buttons">
                <div className="btn btn-primary btn-account">
                  <FormattedMessage id="account-single-order.item.view" defaultMessage="View order & keys" />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </article>
  );
}
